import React, { useState } from 'react';
import {
    Box, Button, Grid, Typography, TextField, MenuItem,
    FormControl, InputLabel, Select, Checkbox, ListItemText,
    OutlinedInput, Chip, Paper
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const sections = [
    'branding', 'licensing', 'marketing', 'suppliers',
    'financials', 'action plan', 'competitors', 'market score',
    'growth strategy', 'risk assessment', 'pitch deck', 'executive summary'
];

const availableFeatures = [
    'AI Roadmap', 'Basic Branding', 'Supplier Discovery', 'Financial Projections',
    'Competitor Landscape', 'Premium Branding', 'Action Plan', 'Custom AI Training',
    'Expert Advisor', 'Full PDF Report', 'Interactive Dashboard'
];

const AddFikraLabPlan = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        internalName: '',
        type: 'free',
        ideas: 3,
        depth: 'Basic',
        format: 'Cards',
        model: 'gpt-4o-mini',
        price: 0,
        features: [],
        enabledSections: ['branding', 'licensing'],
    });

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSectionsChange = (event: any) => {
        const { value } = event.target;
        setFormData(prev => ({
            ...prev,
            enabledSections: typeof value === 'string' ? value.split(',') : value,
        }));
    };

    const handleFeaturesChange = (event: any) => {
        const { value } = event.target;
        setFormData(prev => ({
            ...prev,
            features: typeof value === 'string' ? value.split(',') : value,
        }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        console.log('Saving plan:', formData);
        navigate('/fikra-lab-plans');
    };

    return (
        <div className="add_plan_wrapper">
            <div className="main_title">
                <h1>Add New Plan Profile</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/fikra-lab-plans")}>
                        Fikra Lab Plans
                    </button>{" "}
                    - Add New Plan Profile
                </p>
            </div>

            <div className="cards">
                <div className="form">
                    <div className="gap_m w_100">
                        {/* Profile Name */}
                        <div className="control_group w_50">
                            <label htmlFor="plan-name">Profile Name</label>
                            <TextField
                                fullWidth
                                id="plan-name"
                                placeholder="e.g. Premium Complete"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* Internal Slug */}
                        <div className="control_group w_50">
                            <label htmlFor="plan-internalName">Internal Slug</label>
                            <TextField
                                fullWidth
                                id="plan-internalName"
                                placeholder="e.g. premium_complete"
                                name="internalName"
                                value={formData.internalName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                  
                        {/* Ideas Count */}
                        <div className="control_group w_33">
                            <label htmlFor="plan-ideas">Ideas Count</label>
                            <TextField
                                fullWidth
                                id="plan-ideas"
                                type="number"
                                name="ideas"
                                value={formData.ideas}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* AI Model */}
                        <div className="control_group w_33">
                            <label htmlFor="plan-model">AI Model</label>
                            <FormControl fullWidth>
                                <Select
                                    id="plan-model"
                                    name="model"
                                    value={formData.model}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="gpt-4o-mini">GPT-4o Mini</MenuItem>
                                    <MenuItem value="gpt-4o">GPT-4o (Standard)</MenuItem>
                                    <MenuItem value="gpt-o1">GPT-o1 (Reasoning)</MenuItem>
                                </Select>
                            </FormControl>
                        </div>

                        {/* Content Depth */}
                        <div className="control_group w_50">
                            <label htmlFor="plan-depth">Content Depth</label>
                            <FormControl fullWidth>
                                <Select
                                    id="plan-depth"
                                    name="depth"
                                    value={formData.depth}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Basic">Basic (Summarized)</MenuItem>
                                    <MenuItem value="Detailed">Detailed (Standard)</MenuItem>
                                    <MenuItem value="Comprehensive">Comprehensive (Deep Dive)</MenuItem>
                                </Select>
                            </FormControl>
                        </div>

                        {/* Output Format */}
                        <div className="control_group w_50">
                            <label htmlFor="plan-format">Output Format</label>
                            <FormControl fullWidth>
                                <Select
                                    id="plan-format"
                                    name="format"
                                    value={formData.format}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Cards">Cards View</MenuItem>
                                    <MenuItem value="Tabs">Tabbed Layout</MenuItem>
                                    <MenuItem value="Report">Full PDF Report</MenuItem>
                                    <MenuItem value="Dashboard">Interactive Dashboard</MenuItem>
                                </Select>
                            </FormControl>
                        </div>

                        {/* Plan Price */}
                        <div className="control_group w_50">
                            <label htmlFor="plan-price">Plan Price ($)</label>
                            <TextField
                                fullWidth
                                id="plan-price"
                                type="number"
                                name="price"
                                value={formData.price}
                                onChange={handleChange}
                                placeholder="0 for Free"
                                required
                            />
                        </div>

                        {/* Features Selection */}
                        {/* <div className="control_group w_50">
                            <label>Features Included</label>
                            <FormControl fullWidth>
                                <Select
                                    multiple
                                    name="features"
                                    value={formData.features}
                                    onChange={handleFeaturesChange}
                                    input={<OutlinedInput />}
                                    renderValue={(selected: any) => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {selected.map((value: any) => (
                                                <Chip key={value} label={value} size="small" />
                                            ))}
                                        </Box>
                                    )}
                                    MenuProps={MenuProps}
                                >
                                    {availableFeatures.map((name) => (
                                        <MenuItem key={name} value={name}>
                                            <Checkbox checked={formData.features.indexOf(name as never) > -1} />
                                            <ListItemText primary={name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div> */}

                        {/* Enabled Sections */}
                        <div className="control_group w_100">
                            <label htmlFor="plan-enabledSections">Enabled Sections</label>
                            <FormControl fullWidth>
                                <Select
                                    id="plan-enabledSections"
                                    multiple
                                    value={formData.enabledSections}
                                    onChange={handleSectionsChange}
                                    input={<OutlinedInput />}
                                    renderValue={(selected) => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {selected.map((value) => (
                                                <Chip key={value} label={value} size="small" />
                                            ))}
                                        </Box>
                                    )}
                                    MenuProps={MenuProps}
                                >
                                    {sections.map((name) => (
                                        <MenuItem key={name} value={name}>
                                            <Checkbox checked={formData.enabledSections.indexOf(name) > -1} />
                                            <ListItemText primary={name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>

                        {/* Action Buttons */}
                        <div className="control_group w_100" style={{ marginTop: '20px' }}>
                            <Box display="flex" gap={2}>
                                <Button
                                    variant="contained"
                                    className="btn btn_primary"
                                    onClick={handleSubmit}
                                >
                                    Save Profile
                                </Button>
                                <Button
                                    variant="outlined"
                                    className="btn btn_grey"
                                    onClick={() => navigate('/fikra-lab-plans')}
                                >
                                    Cancel
                                </Button>
                            </Box>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddFikraLabPlan;
